// extracted by mini-css-extract-plugin
export default {"icon":"PlayIcon_icon","pause":"PlayIcon_pause"};